'use client';

import React from 'react';

import RichText from '@/components/ui/RichText/RichText';
import { COMPONENT_STYLES } from '@/constants/styles';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import R2Video from '@/components/ui/R2Video/R2Video';

interface Video {
  title: string;
  url: string;
}

interface VideoSectionData {
  sys: { id: string };
  heading: { json?: any; raw?: string };
  videosCollection?: { items: Video[] };
}

interface VideoSectionProps {
  data?: VideoSectionData;
}

const VideoSection: React.FC<VideoSectionProps> = ({ data }) => {
  const { ref, sectionClasses, childClasses, getChildStyle } =
    useScrollAnimation();

  if (!data) return null;

  const videos = data.videosCollection?.items || [];

  return (
    <section
      ref={ref}
      className={`bg-white py-8 md:py-10 ${sectionClasses}`}
      data-testid="video-section"
    >
      <div className="content-wrapper">
        {/* Section Heading */}
        <div
          className={`text-center ${childClasses()}`}
          style={getChildStyle(200)}
        >
          {data.heading?.raw && (
            <RichText
              styles={{
                p: 'text-3xl md:text-4xl lg:text-5xl font-bold leading-tight text-theme-primary',
              }}
            >
              {data.heading.raw}
            </RichText>
          )}
        </div>

        {/* Videos Grid */}
        {/* Videos Grid */}
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-8 lg:grid-cols-3">
          {videos.map((video, index) => (
            <div
              key={`${data.sys.id}-video-${index}`}
              className={`group ${COMPONENT_STYLES.CARD.GLASS} overflow-hidden rounded-2xl shadow-sm transition-all duration-300 hover:-translate-y-2 hover:shadow-xl ${childClasses()}`}
              style={getChildStyle(400 + index * 100)}
            >
              <R2Video
                path={video.url}
                containerClassName="aspect-video bg-gray-100"
                videoTitle=""
                videoDescription=""
                showLogo={false}
                autoPlayOnView={false}
                defaultMuted={true}
                preload="none"
              />
              <div className="p-3 md:p-4">
                <h3 className="text-theme-primary text-sm font-semibold transition-colors duration-150 group-hover:text-gray-900 md:text-lg">
                  {video.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
